module.exports = __webpack_public_path__ + "img/benefit-card-1-tablet.0522de8b.png";